<template>
  <b-container>
      <b-row class="justify-content-center align-items-center">
          <b-col lg="7" class="p-3">
               <slot name="pr-1" />
          </b-col>
          <b-col lg="5" class="py-3">
              <slot name="pl-1" />
              <slot name="pl-2" />
              <slot name="pl-3" />
                
        

                
          </b-col>
      </b-row>
  </b-container>
</template>

<script>
export default {
    name:'S22'
}
</script>

<style scoped>

</style>